import React, { FC } from 'react';
import { Card, CardBody, CardHeader, Col, FormGroup, Input, Label } from 'reactstrap';
import { LazyMarkdown } from '../../components';

interface ConventionPolicyProps {
  readonly policy: string;
  readonly checked: boolean;
  readonly disabled: boolean;
  onChange(state: boolean): void;
}

export const ConventionPolicy: FC<ConventionPolicyProps> = ({
  policy,
  checked,
  disabled,
  onChange,
}) => {
  return (
    <Col className="margin-bottom-10" lg={12} xs={12}>
      <Card>
        <CardHeader>Convention Policy</CardHeader>
        <CardBody>
          <LazyMarkdown source={policy} />
          <FormGroup>
            <div className="custom-control custom-checkbox margin-top-10">
              <Input
                checked={checked}
                className="custom-control-input"
                disabled={disabled}
                id="agreeConTerms"
                onChange={(e) => onChange(e.target.checked)}
                type="checkbox"
              />
              <Label className="custom-control-label" for="agreeConTerms">
                I have read and agree to the convention policies above.
              </Label>
            </div>
          </FormGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
